// ─── Profile / API ───────────────────────────────────────────────────────────
export const PROFILE_UPDATE_DELAY = 1500;

// ─── Redirect loop guard ─────────────────────────────────────────────────────
export const REDIRECT_LOOP_STORAGE_PREFIX = "redirectLoopGuard:";
export const REDIRECT_LOOP_WINDOW_MS = 20_000;
export const REDIRECT_LOOP_THRESHOLD = 4;
export const LOOP_REDIRECT_QUERY_PARAM = "loopRedirect";

// ─── Permissions ─────────────────────────────────────────────────────────────
export const WILDCARD_SERVICE_NAME = "*";

export type PermissionLevel = "r" | "w" | "*";

export const LEVEL_LABEL: Record<PermissionLevel, string> = {
  r: "Read",
  w: "Write",
  "*": "Admin",
};

export const SERVICE_TYPES = [
  { value: WILDCARD_SERVICE_NAME, label: "All" },
  { value: "cms", label: "Cms" },
  { value: "analytics", label: "Analytics" },
  { value: "live", label: "Live" },
  { value: "chopper", label: "Chopper" },
  { value: "optimus", label: "Optimus" },
  { value: "admin_console", label: "Admin Console" },
  { value: "billing", label: "Billing Dashboard" },
  { value: "compass", label: "Compass AI" },
  { value: "ad_manager", label: "Ad Manager" },
] as const;

export const AVAILABLE_SERVICES = [
  { value: "cms", label: "CMS" },
  { value: "analytics", label: "Analytics" },
  { value: "live", label: "Live" },
] as const;

// ─── App categories ───────────────────────────────────────────────────────────
export const CATEGORY_LABELS: Record<string, string> = {
  content: "Content Management",
  tools: "Tools & Utilities",
  analytics: "Analytics & Insights",
  admin: "Administration",
  other: "Others",
};

export const CATEGORY_ORDER = ["content", "tools", "analytics", "admin", "other"];
